"use client";

import { StorageManagement } from "@/components/settings/storage";

interface StorageScreenProps {
  onBack: () => void;
}

export default function StorageScreen({ onBack }: StorageScreenProps) {
  return <StorageManagement variant="desktop" onBack={onBack} />;
}
